import { useState } from "react";
import { Form, Col, Button, Row, Image } from "react-bootstrap";
import styles from "./Login.module.css";
import { auth, provider } from "../../Auth/FirebaseSetup";
import { signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { Alert } from "react-bootstrap";
import googleLogo from '../../assets/images/Google__G__logo.png'

const Login = (props) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const [alert, setAlert] = useState();
    
    const allowedDomains = ['shop-grok.com', 'shopgrok.com'];

    const handleLogin = async () => {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            setAlert("Login Successful!")
            setError(false)
        } catch (e) {
            // console.log("Incorrect username or password");
            setAlert("Username or Password Incorrect")
            setError(true);
        }
    }

    const handleGoogleSignIn = async() => {
        try {
            const result = await signInWithPopup(auth, provider)
            const user = result.user;

            const emailDomain = user.email.split('@')[1];

            if (!allowedDomains.includes(emailDomain)){
                await signOut(auth);
                setError(true);
                setAlert('Access denied: Unauthorized email domain');
            }
        } catch (error) {
            console.error('Error during sign in:', error);
        }
    }

    return (
        <div>
            {alert && 
                <Alert variant={error ? "danger" : "success"}>
                    {alert}
                </Alert>
            }
            <div className={styles.login}>

                <h2>Log in</h2>
                <Form>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">
                            Email:
                        </Form.Label>
                        <Col sm="10" md={10}>
                            <Form.Control type="text" placeholder="someone@example.com" value={email} onChange={(e) => setEmail(e.target.value)}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">
                            Password:
                        </Form.Label>
                        <Col sm="10" md={10}>
                            <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                        </Col>
                    </Form.Group>
                    {/* <Form.Group as={Row} className="mb-3"> */}
                    {/* </Form.Group> */}
                    <Button onClick={handleLogin}>Log in</Button>
                    <br/>
                    <br/>
                        <Button variant="light" style={{ border: '1px solid black' }} onClick={handleGoogleSignIn}><Image src={googleLogo} style={{ width: '20px', height: '20px', marginRight: '8px' }}/> Log in with Google</Button>
                </Form>
            </div>
        </div>
    );
};

export default Login;